// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader-cont {
    position: fixed;
    z-index: 1000;
    background: #fff;
    width: 100%;
    height: 100%;
    transition: 10s ease-in;
}

.Loader-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 250px;
}

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    opacity: 1;
    /* transition: opacity 1s; */
}

.fade-exit {
    opacity: 1;
}

.fade-exit-active {
    opacity: 0;
    transition: opacity 1s;
}`, "",{"version":3,"sources":["webpack://./src/css/Loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B","sourcesContent":[".Loader-cont {\n    position: fixed;\n    z-index: 1000;\n    background: #fff;\n    width: 100%;\n    height: 100%;\n    transition: 10s ease-in;\n}\n\n.Loader-img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 250px;\n}\n\n.fade-enter {\n    opacity: 0;\n}\n\n.fade-enter-active {\n    opacity: 1;\n    /* transition: opacity 1s; */\n}\n\n.fade-exit {\n    opacity: 1;\n}\n\n.fade-exit-active {\n    opacity: 0;\n    transition: opacity 1s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
